const API_ENDPOINTS = {
  BASE_URL: window.CONFIG.HOSTS_NEEDS_TOKEN,
  TENANTS_GET: '/tenants/',
  TENANTS_POST: '/tenants/',
  TENANTS_PUT: '/tenants/',
  USER_INFO: '/tenants/user-info',
  ORGANIZATION_DELETE: '/organization/organization/',
  ORGANIZATION_IDENTITY_PROVIDER: '/organization/identity_provider/',
  ORGANIZATION_IDENTITY_PROVIDER_ENABLE_DISABLE_POST:
    '/enable_disable_ip_settings/',
  ORGANIZATION_IDENTITY_PROVIDER_CHANGE_STATUS: '/enable_disable_ip_settings/',

  // CERTIFICATE
  CERTIFICATE_LIST_GET: '/auth/certificate',
  REFRESH_CERTIFICATE_KEY: '/auth/certificate/',

  // IDP
  IDENTITY_PROVIDER_LIST_GET: '/tenants/idp/',
  IDENTITY_PROVIDER_DELETE: '/tenants/idp/',
  IDENTITY_PROVIDER_SAML_POST: '/tenants/saml/',
  IDENTITY_PROVIDER_UPDATE_SAML: '/tenants/saml/',
  IDENTITY_PROVIDER_OIDC_POST: '/tenants/oidc/',
  IDENTITY_PROVIDER_UPDATE_OIDC: '/tenants/oidc/',
  IDENTITY_PROVIDER_MAPPING: '/auth/idp-mapping/',

  // CLAIM MAPPING
  CLAIM_MAPPING: '/auth/claim-mapping/',

  // LDAP MAPPER
  GET_LDAP_MAPPER: '/get_ldap_mappers/',
  ADD_LDAP_MAPPER: '/add_ldap_mappers/',
  DELETE_LDAP_MAPPER: '/delete_ldap_mapper/',
  UPDATE_LDAP_MAPPER: '/update_ldap_mappers/',

  // APIKEY
  GET_APIKEY_LIST_API: '/auth/api-key/',
  CREATE_APIKEY_API: '/auth/api-key/',
  UPDATE_APIKEY_API: '/auth/api-key/',
  DELETE_APIKEY_API: '/auth/api-key/',
  GET_APIKEY_DETAILS: '/auth/api-key/',
  GET_PRODUCT_SERVICE: '/auth/service/',

  // SUBADMIN
  GET_SUBADMIN_GROUP_LIST: '/admin_group',
  PATCH_SUBADMIN_GROUP: '/admin_group',
  GET_SUBADMIN_USER_LIST: '/tenants/tenant-admin/list/',
  POST_SUBADMIN_USER: '/tenants/tenant-admin/list/',
  PATCH_SUBADMIN_USER: '/tenants/tenant-admin/',
  DELETE_SUBADMIN_USER: '/tenants/tenant-admin/',

  // PASSWORD
  BASE_URL_PASSWORD: '/tenants/',
  GET_PASSWORD: 'setting',
  PUT_PASSWORD: 'setting/',

  // ORCHESTRATION
  BASE_URL_ORCHESTRATION: '/orchestration/',
  GET_VERSION_LIST: '/settings/versions',
  GET_VERSION_DETAIL: '/settings/versions/',
  GET_INITIAL_DETAIL: '/settings',
  POST_ORCHESTRATION: '/settings',

  // LDAP
  BASE_URL_LDAP: '/organization/organization/',
  POST_TEST_CONNECTION: '/test_ldap_connection/',
  POST_TEST_CREDENTIAL: '/test_ldap_credentials/',
  GET_LDAP: '/get_ldaps',
  CREATE_LDAP: '/setup_ldap_connection/',
  LDAP_ACTION: '/actions_on_ldap/',
  UPDATE_LDAP: '/update_ldap_connection/',
  DELETE_LDAP: '/delete_ldap/',
  STATUS_LDAP: '/status_ldap/',

  // WEBHOOKS
  GET_WEBHOOK_LIST_API: '/organization/webhook/',
  CREATE_WEBHOOK_API: '/organization/webhook/',
  UPDATE_WEBHOOK_API: '/organization/webhook/',
  DELETE_WEBHOOK_API: '/organization/webhook/',
  GET_WEBHOOK_EVENT_API: '/organization/webhook_event',

  // LOGIN
  LOGIN_BASE_URL: '/tenants',
  LOGIN_PUT: '/login-setting/',
  LOGIN_GET: '/login-setting/',
  SAVE_THEME: '/tenants/save-theme/',

  // ACTIVE DIRECTORY
  BASE_URL_ACTIVE_DIRECTORY: '/organization/organization/',
  CREATE_ACTIVE_DIRECTORY: '/setup_ad_settings/',
  GET_ACTIVE_DIRECTORY: '/get_ad_settings/',
  PUT_ACTIVE_DIRECTORY: '/enable_disable_ad_settings/',
  DELETE_ACTIVE_DIRECTORY: '/delete_ad_settings/',

  // APPLICATION DETAILS
  GET_APPLICATION_LIST: '/products',
  PATCH_APPLICATION: '/products/',
  DELETE_APPLICATION: '/products/',
  POST_APPLICATION: '/products/',
  GET_PRODUCT_LIST: '/base-products/',
  GET_CODE: '/user/config_json',
  POST_CODE: '/user/config_json',
  POST_PRODUCT_LIST: '/organization/product/',
  GET_THEME_PRODUCT: '/tenants/template',
  POST_THEME_PRODUCT: '/tenants/template',
  DEFAULT_THEME_PRODUCT: '/default-templates',
  GET_FILE_CONFIG: '/products/config/',
  EDIT_FILE_CONFIG: '/products/config/',
  GET_DB_CONFIG: '/products/reset-config/',
  CREATE_PRODUCT_SERVICES: '/auth/service/',

  // WEBHOOK DETAILS
  GET_WEBHOOK_LIST: 'organization/webhook_test',

  // GROUP DETAILS
  GET_GROUP_LIST: '/groups/rogue/',
  CREATE_GROUP_LIST: '/groups/',
  POST_GROUP_LIST: '/user/group',
  UPDATE_PERMISSION: '/groups/',
  DELETE_GROUP: '/groups/',
  GET_MEMBER_LIST: '/groups',
  GET_DEFAULT_PERMISSION: '/groups/permissions/',

  GET_USER_DETAILS: '/users/',
  CREATE_USER_DETAILS: '/users/register/',
  UPDATE_USER_DETAILS: '/users/',
  DELETE_USER_DETAILS: '/users/',
  SYNC_USERS: '/users/sync-all-users/',
  RESET_USER_PASSWORD: '/user/reset_user_password',
  RESET_SUB_ADMIN_USER_PASSWORD: 'reset_admin_user_password/',
  ORGANIZATION_EMAIL_POST: '/tenants/email-settings',
  ORGANIZATION_EMAIL_GET: '/tenants/email-settings',
  ORGANIZATION_EMAIL_PATCH: '/tenants/email-settings',
  ORGANIZATION_UPLOADFILE_POST: '/user/csv_user',

  // Login routes
  AUTH_LOGIN: '/root/login/',
  AUTH_LOGOUT: '/root/logout/',
  GET_ALL_TENANTS: '/tenants/',
  LOGIN_PRODUCT: '/auth/login/',
  GET_PRODUCT_LIST_WITH_TENANT: '/products',
  GET_TOKEN_WITH_AUTH_CODE: '/auth/token/',
  FORGOT_PASSWORD: '/auth/forget-password/',
  RESET_PASSWORD: '/auth/reset-password/',
  FORGOT_PASSWORD_SUBADMIN: '/forgot-password/',
  RESET_PASSWORD_SUBADMIN: '/reset-password/',
  IDP_WITHOUT_AUTH: '/tenants/get-active-idp',
  IDP_LOGIN: '/auth/idp/login',
  IDP_GET_TOKEN_WITH_CODE: '/auth/callback/',
  CHECK_ACTIVE_SESSION: '/auth/session/login/',
  CSRF_TOKEN: '/auth/csrf',

  // Logs
  GET_USER_STATS: '/auth/logs/prepare-user-stats',
  GET_ACCESS_LOG: '/tenants/access-logs',
  GET_AUDIT_LOG: '/tenants/audit-logs',
  DOWNLOAD_LOG: '/tenants/logs/download',
};

export default API_ENDPOINTS;
